import React, { useEffect } from 'react';
import { useReservationForm } from './hooks/ReservationForm.hook';
import ReservationFormView from './views/ReservationFormView';
import LoadingComponent from '@/components/general/Loading/LoadingComponent';

const ReservationFormController = (props) => {
  const { className, spaceDetail, backButton } = props;
  const { isLoading, goToCheckout } = useReservationForm(spaceDetail);
  if (isLoading) {
    return <LoadingComponent loading={isLoading} />;
  } else {
    return (
      <ReservationFormView
        className={className}
        spaceDetail={spaceDetail}
        onSubmitFunction={goToCheckout}
        backButton={backButton}
      />
    );
  }
};

export default ReservationFormController;
